import React from 'react'
import { FormattedMessage } from 'react-intl'

import { Small } from '@components/Text'
import SMBAppbar from '@components/Appbar'

import { Locker } from '@assets/icons'

import Icon from './Appbar.style'

export default function Appbar() {
  return (
    <SMBAppbar>
      <Icon>
        <img src={Locker} alt="" />
      </Icon>

      <Small>
        <FormattedMessage id="smb_acquisition_company_info.nav_bar.security_warning" />
      </Small>
    </SMBAppbar>
  )
}
